import { lazy } from "react";
import { Navigate } from "react-router-dom";
import Loadable from "../../../component/Loadable";
import MinimalLayout from "../../../layout/MinimalLayout";
import CustomerPortalGuard from "./CustomerPortalGuard";

const CustomerPortalLogin = Loadable(lazy(() => import("../pages/Login")));
const CustomerPortalForgotPassword = Loadable(lazy(() => import("../pages/ForgotPassword")));
const CustomerPortalLayout = Loadable(lazy(() => import("../pages/layout/CustomerPortalLayout")));
const CustomerPortalDashboard = Loadable(lazy(() => import("../pages/Dashboard")));
const CustomerPortalAppointments = Loadable(lazy(() => import("../pages/Appointments")));
const CustomerPortalEditAppointment = Loadable(lazy(() => import("../pages/EditAppointment")));
const CustomerPortalCheckout = Loadable(lazy(() => import("../pages/Checkout")));
const CustomerPortalSubscriptions = Loadable(lazy(() => import("../pages/Security")));
const CustomerPortalPackages = Loadable(lazy(() => import("../pages/Profile")));
const CustomerPortalPurchaseHistory = Loadable(lazy(() => import("../pages/PurchaseHistory")));
const CustomerPortalWaitlist = Loadable(lazy(() => import("../pages/Waitlist")));

const CustomerPortalRoutes = {
  path: "/customer-portal",
  children: [
    {
      element: <MinimalLayout />,
      children: [
        { path: "", element: <Navigate to="/customer-portal/login" replace /> },
        { path: "login", element: <CustomerPortalLogin /> },
        { path: "forgot-password", element: <CustomerPortalForgotPassword /> },
      ],
    },
    {
      element: (
        <CustomerPortalGuard>
          <CustomerPortalLayout />
        </CustomerPortalGuard>
      ),
      children: [
        { path: "dashboard", element: <CustomerPortalDashboard /> },
        { path: "appointments", element: <CustomerPortalAppointments /> },
        { path: "appointments/new", element: <CustomerPortalEditAppointment /> },
        { path: "appointments/:appointmentId/edit", element: <CustomerPortalEditAppointment /> },
        { path: "appointments/:appointmentId/reschedule", element: <CustomerPortalEditAppointment /> },
        { path: "appointments/checkout", element: <CustomerPortalCheckout /> },
        { path: "subscriptions", element: <CustomerPortalSubscriptions /> },
        { path: "packages", element: <CustomerPortalPackages /> },
        { path: "purchase-history", element: <CustomerPortalPurchaseHistory /> },
        { path: "waitlist", element: <CustomerPortalWaitlist /> },
      ],
    },
  ],
};

export default CustomerPortalRoutes;
